<div class="product">
  <!-- details / outline -->
  <div
    class="product__focus"
    [ngClass]="{
      'product__focus--touch': isCollapsible,
      'product__focus--invalid': isInvalid
    }"
    (click)="onClick()">
    <div class="row">
      <div class="col-12 col-lg-6 pr-5 pr-lg-3 align-self-center">
        <span class="product__name">{{ product.name }}</span>
      </div>
      <div class="col-6 col-lg-3 mt-2 mt-lg-0 p-lg-0">
        <!-- if packaged / loan amount -->
        <ng-container *ngIf="isPackaged">
          <div class="product__label">amount</div>
          <div class="product__text">
            {{ product.loanAmount | currency: '':'symbol-narrow':'1.0-0' }}
          </div>
        </ng-container>
      </div>
      <div class="col-6 col-lg-3 mt-2 mt-lg-0 pl-none text-right">
        <div class="product__label">total repayments</div>
        <div class="product__text">
          {{
            ceiling(product.totalRepayments)
              | currency: '':'symbol-narrow':'1.0-0'
          }}
        </div>
      </div>
    </div>
  </div>

  <!-- details / secondary -->
  <div
    class="product__details"
    [ngClass]="{ 'product__details--hidden': isCollapsed }">
    <div class="row">
      <div class="col-8 col-xl-4 p-xl-0">
        <!-- structure -->
        <div class="product__label">rate / term / type</div>

        <ng-container *ngIf="product.structure.singleTerm">
          <div class="product__text">
            {{ product.structure.singleTerm.rate | percent: '1.2' }}
            <span class="info-divider"></span>
            {{ product.structure.singleTerm.term | formatLoanTerm: true }}
            <span class="info-divider"></span>
            {{ product.structure.singleTerm.rateType }}
          </div>
        </ng-container>
        <ng-container *ngIf="product.structure.multiTerm">
          <div class="product__text">
            {{ product.structure.multiTerm.initialTerm.rate | percent: '1.2' }}
            <span class="info-divider"></span>
            {{
              product.structure.multiTerm.initialTerm.term
                | formatLoanTerm: true
            }}
            <span class="info-divider"></span>
            {{ product.structure.multiTerm.initialTerm.rateType }}
          </div>
          <!-- Only show revert term if not bridging product or reverse mortgage -->
          <div class="product__text" *ngIf="(product.structure | filterProductTerms : product.features : false).length > 1">
            {{ product.structure.multiTerm.revertTerm.rate | percent: '1.2' }}
            <span class="info-divider"></span>
            {{
              product.structure.multiTerm.revertTerm.term | formatLoanTerm: true
            }}
            <span class="info-divider"></span>
            {{ product.structure.multiTerm.revertTerm.rateType }}
          </div>
        </ng-container>
      </div>
      <div class="col-4 col-xl-2 text-right">
        <!-- repayments -->
        <div class="product__label">{{ product.repaymentFrequency }}</div>

        <ng-container *ngIf="product.structure.singleTerm">
          <div class="product__text">
            {{
              product.structure.singleTerm.repayments
                | currency: '':'symbol-narrow':'1.0-0'
            }}
          </div>
        </ng-container>
        <ng-container *ngIf="product.structure.multiTerm">
          <div class="product__text">
            {{
              product.structure.multiTerm.initialTerm.repayments
                | currency: '':'symbol-narrow':'1.0-0'
            }}
          </div>
          <!-- Only show revert repayments if not bridging product or reverse mortgage -->
          <div class="product__text" *ngIf="(product.structure | filterProductTerms : product.features : false).length > 1">
            {{
              product.structure.multiTerm.revertTerm.repayments
                | currency: '':'symbol-narrow':'1.0-0'
            }}
          </div>
        </ng-container>
      </div>
      <div class="col-12 col-xl-6 order-xl-first">
        <!-- loan fees -->
        <div
          class="product__fees d-flex justify-content-between justify-content-xl-start">
          <div class="mr-4">
            <div class="product__label">set up</div>
            <div class="product__text">
              {{ product.setupFees | currency: '':'symbol-narrow':'1.0-0' }}
            </div>
          </div>
          <div class="mr-4 text-center text-lg-left">
            <div class="product__label">monthly</div>
            <div class="product__text">
              {{ product.monthlyFees | currency: '':'symbol-narrow':'1.0-0' }}
            </div>
          </div>
          <div class="mr-0 text-right text-lg-left">
            <div class="product__label">annual</div>
            <div class="product__text">
              {{ product.annualFees | currency: '':'symbol-narrow':'1.0-0' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
